import { ReactComponent as CodeIcon } from 'assets/icons/programming/code.svg';
import { ReactComponent as DocumentCodeIcon } from 'assets/icons/programming/document-code.svg';

export const programming = {
  code: CodeIcon,
  'document-code': DocumentCodeIcon,
};
